import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id } from '../../model/model'
import { Diary, VisionTherapyApi } from '../../model/exam'

const initialState: VisionTherapyApi = {
	diaries: {
		current: { examDate: new Date().toISOString() },
		previous: [],
	},
	recommendation: '',
}

export const slice = createSlice({
	name: 'visionTherapy',
	initialState,
	reducers: {
		_loadVisionTherapy: (state, { payload }: PayloadAction<VisionTherapyApi>) =>
			payload,
		_setCurrentVisionTherapy: (state, { payload }: PayloadAction<Diary>) => {
			state.diaries.current = payload
		},
	},
})

export default slice.reducer
